import { Check } from 'lucide-react';

import { cn } from '@/lib/utils';

export interface StepDescriptor {
  id: string;
  label: string;
}

interface Props {
  steps: ReadonlyArray<StepDescriptor>;
  currentIndex: number;
}

const Stepper = ({ steps, currentIndex }: Props) => (
  <ol className="flex w-full items-center gap-2">
    {steps.map((step, index) => {
      const isCompleted = index < currentIndex;
      const isCurrent = index === currentIndex;
      return (
        <li key={step.id} className="flex flex-1 items-center gap-3">
          <div
            className={cn(
              'flex size-8 shrink-0 items-center justify-center rounded-full border text-sm font-semibold',
              isCompleted && 'border-brand-turquoise bg-brand-turquoise text-white',
              isCurrent && 'border-brand-turquoise text-brand-turquoise',
              !isCompleted && !isCurrent && 'border-border text-text-muted'
            )}
          >
            {isCompleted ? <Check className="size-4" /> : index + 1}
          </div>
          <div className="flex-1">
            <p
              className={cn(
                'text-xs font-semibold uppercase tracking-wider',
                isCurrent ? 'text-brand-turquoise' : 'text-text-muted'
              )}
            >
              Paso {index + 1}
            </p>
            <p className={cn('text-sm font-medium', isCurrent ? 'text-text-default' : 'text-text-muted')}>
              {step.label}
            </p>
          </div>
          {index < steps.length - 1 && (
            <div className={cn('h-px flex-1 bg-border', index < currentIndex && 'bg-brand-turquoise')} />
          )}
        </li>
      );
    })}
  </ol>
);

export default Stepper;
